import { useState } from "react";

import { RefreshIcon } from "@/assets/icons";
import { useModal } from "@/context/ModalProvider";

import { Button } from "equator-design-system";
import { twMerge } from "tailwind-merge";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle
} from "./dialog";

const ConfirmationModal = () => {
  const { modalState, closeModal } = useModal();
  const [isLoading, setIsLoading] = useState(false);

  if (!modalState?.type) return;

  if (modalState.type === "confirm") {
    const { title, message, cancelLabel, confirmLabel, onConfirm, onCancel } =
      modalState.props;

    return (
      <Dialog open onOpenChange={closeModal}>
        <DialogContent
          isHideClose
          className="!rounded-xl p-0"
          aria-describedby="confirm-modal-description"
          zIndex={1001}
        >
          <DialogDescription className="sr-only">
            Confirmation Modal
          </DialogDescription>
          <DialogTitle className="hidden" />
          <div className="flex flex-col items-center gap-3 max-w-[500px] p-6">
            <span className="text-xl font-semibold text-txtHeading">
              {title}
            </span>
            <span className="text-sm text-center px-2">{message}</span>
            <div className="flex justify-center w-full gap-2 mt-2">
              <Button
                variant="secondary"
                className="h-[40px] w-[210px] btn-secondary text-sm !font-bold disabled:cursor-not-allowed"
                disabled={isLoading}
                onMouseUp={(e) => {
                  e.stopPropagation();
                }}
                onClick={async () => {
                  setIsLoading(true);
                  await onCancel?.();
                  setIsLoading(false);
                  closeModal();
                }}
              >
                <span>{cancelLabel}</span>
              </Button>
              <Button
                className={twMerge(
                  "h-[40px] w-[210px] btn-primary text-sm !font-bold",
                  isLoading ? "cursor-wait" : "cursor-pointer"
                )}
                disabled={isLoading}
                aria-label={isLoading ? "loading" : confirmLabel}
                onMouseUp={(e) => {
                  e.stopPropagation();
                }}
                onClick={async () => {
                  setIsLoading(true);
                  await onConfirm?.();
                  setIsLoading(false);
                  closeModal();
                }}
              >
                <span>
                  {isLoading ? (
                    <RefreshIcon className="fill-white w-5 animate-spin duration-1000 h-5" />
                  ) : (
                    confirmLabel
                  )}
                </span>
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
};

export default ConfirmationModal;
